import { Component, Input, OnChanges, Output, EventEmitter, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-confirm-delete-dialog',
  templateUrl: './confirm-delete-dialog.component.html',
  styleUrls: ['./confirm-delete-dialog.component.scss'],
  standalone: false
})
export class ConfirmDeleteDialogComponent implements OnChanges {
  @Input() visible = false;
  @Input() itemName = '';
  @Input() itemType = 'item';
  /** When > 1 the dialog speaks in bulk terms ("3 locations") instead of itemName. */
  @Input() count = 0;
  /**
   * Which delete paths this consumer supports:
   * - 'both': archive or permanent (default)
   * - 'permanent': hard delete only (no archive/restore exists for the item)
   * - 'archive': soft removal only (item moves to a recoverable state)
   */
  @Input() mode: 'both' | 'permanent' | 'archive' = 'both';
  /** Optional extra context line (e.g. "Everything inside is included."). */
  @Input() message = '';
  @Output() archive = new EventEmitter<void>();
  @Output() permanentDelete = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  choice: 'archive' | 'permanent' = 'archive';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible']?.currentValue || changes['mode']) {
      this.choice = this.mode === 'permanent' ? 'permanent' : 'archive';
    }
  }

  get isBulk(): boolean {
    return this.count > 1;
  }

  get displayName(): string {
    return this.isBulk ? `${this.count} ${this.itemType}s selected` : this.itemName;
  }

  confirm(): void {
    if (this.choice === 'archive') this.archive.emit();
    else this.permanentDelete.emit();
    this.choice = this.mode === 'permanent' ? 'permanent' : 'archive';
  }

  onCancel(): void {
    this.choice = this.mode === 'permanent' ? 'permanent' : 'archive';
    this.cancel.emit();
  }
}
